export enum AuditInviteState {
  All = 'all',
  Open = 0,
  Completed = 1,
  Canceled = 2,
}
